export default __webpack_public_path__ + "static/health_card_desktop-ff9ca2d7a32f8760242450871c21e94d.png";